import React from 'react';
import classnames from 'classnames/bind';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { SearchIcon } from '../SearchIcon/SearchIcon';
import styles from './BreadcrumbsSearchComponent.module.scss';

const classNameBuilder = classnames.bind(styles);

export const BreadcrumbsSearchComponent = ({
    inputValue = '',
    onInputChange,
    inputRef,
    onKeyDown,
    SortComponent,
    isOpen,
    ...rest
}) => {
    const intl = useIntl();

    const handleInputChange = e => {
        if (onInputChange) {
            onInputChange(e.target.value);
        }
    };

    return (
        <div className={classNameBuilder('wrapper')} data-automation="breadcrumbs_search_input">
            <div className={classNameBuilder('input-container')}>
                <SearchIcon />
                <input
                    type="text"
                    className={classNameBuilder('breadcrumbs-select-input')}
                    value={inputValue}
                    placeholder={intl.formatMessage({
                        id: 'app.collapsible.picker.search.placeholder',
                        defaultMessage: 'Search',
                    })}
                    onChange={handleInputChange}
                    ref={inputRef}
                    autoFocus
                    onKeyDown={onKeyDown}
                    {...rest}
                />
            </div>

            {SortComponent && isOpen && (
                <div className={classNameBuilder('sort-container')}>
                    <SortComponent />
                </div>
            )}
        </div>
    );
};
